module.exports = __webpack_public_path__ + "static/media/create-order-icon.9367ae4b.PNG";